var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BowContentStickyMedia',{attrs:{"type":"dx","htmlTag":_vm.htmlTag,"contentList":_vm.contentList,"isActivity":_vm.isActivity,"media":_vm.media,"text":_vm.text,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }